import React from "react";
import BreadSlider from "./BreadSlider";
import HeroSlider from "./HeroSlider";
import HomeProduct from "./HomeProduct";
// import Categories from "./Category";

const HomePage = () => (

    <div className="main-content">
        <BreadSlider />
        <HeroSlider />
        <HomeProduct />
        {/* <Categories /> */}
    </div>

);

export default HomePage;
